// src/pages/finance-portal/inventory/components/inventoryFormatters.js
//
// Shared formatters and color maps for the  UI.

export const FONT_FAMILY = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";
export const INV_ACCENT = '#0891b2';            // teal — the inventory module color
export const INV_ACCENT_DARK = '#0e7490';

export function formatCurrency(amount, currency = 'USD') {
    if (amount == null || Number.isNaN(amount)) return '$0.00';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (e) {
        return `${currency} ${Number(amount).toFixed(2)}`;
    }
}

export function formatQty(n, decimals = 2) {
    if (n == null || Number.isNaN(n)) return '0';
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
    }).format(n);
}

export function formatDate(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric',
    });
}

export function formatDateTime(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric',
        hour: 'numeric', minute: '2-digit',
    });
}

export const PRODUCT_STATUS_COLORS = {
    ACTIVE:       { bg: '#dcfce7', color: '#166534' },
    DRAFT:        { bg: '#fef3c7', color: '#92400e' },
    DISCONTINUED: { bg: '#fee2e2', color: '#991b1b' },
    ARCHIVED:     { bg: '#e5e7eb', color: '#374151' },
};

export const PRODUCT_TYPE_COLORS = {
    INVENTORY:     { bg: '#dbeafe', color: '#1e40af' },
    NON_INVENTORY: { bg: '#f3e8ff', color: '#6b21a8' },
    SERVICE:       { bg: '#fce7f3', color: '#9f1239' },
    BUNDLE:        { bg: '#fef3c7', color: '#854d0e' },
    DIGITAL:       { bg: '#dcfce7', color: '#166534' },
};

export const PO_STATUS_COLORS = {
    DRAFT:              { bg: '#fef3c7', color: '#92400e' },
    PENDING_APPROVAL:   { bg: '#fee2e2', color: '#991b1b' },
    APPROVED:           { bg: '#dbeafe', color: '#1e40af' },
    SENT:               { bg: '#e0e7ff', color: '#3730a3' },
    ACKNOWLEDGED:       { bg: '#ddd6fe', color: '#4c1d95' },
    PARTIALLY_RECEIVED: { bg: '#fef3c7', color: '#713f12' },
    RECEIVED:           { bg: '#dcfce7', color: '#166534' },
    CLOSED:             { bg: '#e5e7eb', color: '#374151' },
    CANCELLED:          { bg: '#fecaca', color: '#7f1d1d' },
    REJECTED:           { bg: '#fee2e2', color: '#991b1b' },
};

export const RECEIPT_STATUS_COLORS = {
    DRAFT:      { bg: '#fef3c7', color: '#92400e' },
    INSPECTING: { bg: '#fed7aa', color: '#9a3412' },
    POSTED:     { bg: '#dcfce7', color: '#166534' },
    CANCELLED:  { bg: '#fecaca', color: '#7f1d1d' },
};

export const ADJUSTMENT_STATUS_COLORS = {
    DRAFT:            { bg: '#fef3c7', color: '#92400e' },
    PENDING_APPROVAL: { bg: '#fed7aa', color: '#9a3412' },
    APPROVED:         { bg: '#dcfce7', color: '#166534' },
    POSTED:           { bg: '#dcfce7', color: '#166534' },
    REJECTED:         { bg: '#fee2e2', color: '#991b1b' },
    VOID:             { bg: '#e5e7eb', color: '#374151' },
};

export const INSPECTION_COLORS = {
    PASS:          { bg: '#dcfce7', color: '#166534' },
    FAIL:          { bg: '#fee2e2', color: '#991b1b' },
    HOLD:          { bg: '#fef3c7', color: '#92400e' },
    NOT_INSPECTED: { bg: '#e5e7eb', color: '#374151' },
};

export const MATCH_STATUS_COLORS = {
    MATCHED:         { bg: '#dcfce7', color: '#166534' },
    PRICE_VARIANCE:  { bg: '#fed7aa', color: '#9a3412' },
    QTY_VARIANCE:    { bg: '#fed7aa', color: '#9a3412' },
    OVER_RECEIVED:   { bg: '#fee2e2', color: '#991b1b' },
    UNDER_BILLED:    { bg: '#fef3c7', color: '#713f12' },
    UNMATCHED:       { bg: '#e5e7eb', color: '#374151' },
    EXCEPTION:       { bg: '#fecaca', color: '#7f1d1d' },
};

export function statusChip(status, colorMap) {
    const c = colorMap[status] || { bg: '#e5e7eb', color: '#374151' };
    return { backgroundColor: c.bg, color: c.color };
}
